<div class="tag" [class.wrong-email]="!regex.test(info)">
  <div class="tag-size">
      <div class="tag-text">
        <ng-container>{{ info }}</ng-container>
      </div>
      <span (click)="remove()" class="icon-close_small">
      </span>
  </div>
</div>
